export default "__VITE_ASSET__DsUpBPSN__"